var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "page-dialog center-dialog",
      attrs: {
        title: _vm.gameData ? "编辑游戏" : "新增游戏",
        visible: _vm.isVisible,
        "close-on-click-modal": false,
        width: "480px",
      },
      on: { closed: _vm.handleDialogClosed, close: _vm.handleCancel },
    },
    [
      _c(
        "el-form",
        {
          ref: "gameFormRef",
          attrs: {
            model: _vm.formData,
            rules: _vm.formRules,
            "label-width": "80px",
            size: "small",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "排序", prop: "sort" } },
            [
              _c("el-input-number", {
                attrs: {
                  controls: false,
                  min: 1,
                  step: 1,
                  placeholder: "请输入排序",
                  size: "small",
                },
                model: {
                  value: _vm.formData.sort,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "sort", $$v)
                  },
                  expression: "formData.sort",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [_c("el-col", { attrs: { span: 12 } })],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "游戏标签", prop: "tags" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    multiple: "",
                    placeholder: "请选择游戏标签",
                    size: "small",
                  },
                  model: {
                    value: _vm.formData.tags,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "tags", $$v)
                    },
                    expression: "formData.tags",
                  },
                },
                _vm._l(_vm.tagsList, function (item) {
                  return _c(
                    "el-option",
                    {
                      key: item.id,
                      attrs: { label: item.title, value: item.title },
                    },
                    [
                      _c("span", { staticStyle: { "margin-right": "10px" } }, [
                        _vm._v(_vm._s(item.title)),
                      ]),
                      _c(
                        "el-tag",
                        { attrs: { type: "success", size: "small" } },
                        [_vm._v(_vm._s(item.status === 1 ? "启用" : "禁用"))]
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "状态", prop: "status" } },
            [
              _c(
                "el-radio-group",
                {
                  attrs: { size: "small" },
                  model: {
                    value: _vm.formData.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "status", $$v)
                    },
                    expression: "formData.status",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("启用")]),
                  _c("el-radio", { attrs: { label: 2 } }, [_vm._v("禁用")]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 12 } }),
              _c("el-col", { attrs: { span: 12 } }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "template",
        { slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.handleCancel } },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small", loading: _vm.loading },
              on: { click: _vm.handleConfirm },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }